import { AnalyticsEvent } from "../models";

export class AlternatePickupLocationsVisibleEvent implements AnalyticsEvent {
  name = 'AlternatePickupLocationsVisibleEvent';
}